<section class="sect-digi">
    <img src="./assets/digi-img1.png" alt="" class="texture">
    <img src="./assets/digi-img2.png" alt="" class="texture">
    <h2> <span>Digitalizá </span><br />tus consorcios</h2>
    <div class="digi-grid">
        <div class="digi-child digi-child1">
            <p class="digi-title">Control/Mantenimiento <span>preventivo</span></p>
            <p>AdminAI pregunta periódicamente a consorcistas si hay algo faltante o algún  desperfecto que reportar. Evitá reclamos antes de que ocurran.</p>
        </div>
        <div class="digi-child digi-child1">
            <p class="digi-title"><span>Agenda digital</span> de ammenities </p>
            <p>Permite la reserva de espacios comunes desde Whatsapp y lleva un registro de usuarios. </p>
        </div>
        <div class="digi-child digi-child1">
            <p class="digi-title">Estructura edilicia<span> digital</span></p>
            <p>Permite responder a los consorcistas preguntas sobre llaves de paso, caños maestros y cuestiones estructurales que suelen ser requeridas en casos de urgencia.</p>
        </div>
        <div class="digi-child digi-child1">
            <p class="digi-title">Reclamos de <span>convivencia</span> </p>
            <p>¿Alguien no está respetando las reglas? AdminAI atiende al denunciante, avisa al infractor sin revelar su nombre y genera un reporte de la situación al administrador.  </p>
        </div>
    </div>
</section>